import { useId } from "react";

export function Select({
  value,
  onChange = () => {},
  disabled = false,
  children,
  placeholder = "",
  floating = true,
  required = true,
  helpText = "",
}) {
  const id = useId();

  return (
    <div className={floating ? "form-floating" : ""}>
      {!floating && (
        <label className="form-label" htmlFor={id}>
          {placeholder}
        </label>
      )}

      <select
        id={id}
        className="form-select"
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        style={{ textOverflow: "ellipsis" }}
      >
        <option value="" hidden>
          Seleccione
        </option>

        {children}
      </select>

      {floating && (
        <label className="form-label" htmlFor={id}>
          {placeholder}
        </label>
      )}

      <small className="form-text text-muted">{helpText}</small>
    </div>
  );
}
